import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = { open: { type: Boolean, default: false } }

  toggle() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    this.contentTarget.classList.toggle("is-open", this.openValue)
    const header = this.element.querySelector("[aria-expanded]")
    if (header) header.setAttribute("aria-expanded", this.openValue)
  }
}
